
<template>
  <!--  新增题库-->
  <div class="wrap" v-loading="loading"  :element-loading-text="loadingText">
    <el-form ref="form" :model="form" label-width="130px" >
      <el-form-item label="题库名称" style="width: 100%">
        <el-input v-model="form.title" style="width: 60%"  v-if="$route.query.type !== 'check'"></el-input>
        <span v-else>{{form.title}}</span>
        <div style="display: inline-block;float:right">
          <el-button  @click="handleAddQuestion(1)" style="color: #4095E5;border-color: #4095E5" v-if="$route.query.type !== 'check'">新增试题</el-button>
<!--          <el-button type="primary" @click="handleImport" style="color: #fff;background-color: #81B337" v-if="$route.query.type !== 'check'">一键导入题库信息</el-button>-->
          <el-upload
              v-if="$route.query.type !== 'check'"
              style="display: inline-block;margin-left: 10px;border:none"
              action="/api/upload_application_word/"
              list-type="text"
              class="upload"
              accept=".xls,.xlsx"
              :show-file-list="false"
              :multiple="true"
              :file-list="fileList"
              :headers="uploadHeaders"
              :before-upload="handleBeforeUpload"
              :on-change="handleChangeUpload"
              :on-remove="handleRemove"
              :http-request="handleUpload">
            <el-button  class=" font_fit" type="primary" style="color: #fff;background-color: #81B337;border:none">一键导入题库信息</el-button>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item label="题库描述" style="width: 100%">
        <el-input type="textarea" v-model="form.remarks" style="width: 80%"  v-if="$route.query.type !== 'check'"></el-input>
        <span v-else>{{form.remarks}}</span>
        <div style="display: inline-block;float:right;margin-top: -24px"  v-if="$route.query.type !== 'check'">
          <el-button type="text" @click="handleConfirmExport" style="color:#6C6C6C">下载题库模板>>></el-button>
        </div>
      </el-form-item>
      <el-form-item label="题目列表"  >
        <el-table :data="quetionList" border max-height="550">
          <el-table-column label="#" width="50"  type="index"></el-table-column>
          <el-table-column label="题目" min-width="200">
            <template v-slot="{row}">
              <span>{{row.title}}</span>
            </template>
          </el-table-column>
          <el-table-column label="选项信息" min-width="150">
            <template v-slot="{row}">
              <span>{{row.options_str}}</span>
            </template>
          </el-table-column>
          <el-table-column label="正确答案" width="100">
            <template v-slot="{row}">
              <span>{{row.correct_letters}}</span>
            </template>
          </el-table-column>
          <el-table-column label="题型" width="100">
            <template v-slot="{row}">
              <span>{{getQuestionType(row.question_type)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template v-slot="{row}">
             <span class="status_tag" :style="row.status=='4001'?'background:#4787F0':'background:#F4CE98'">{{row.status ==4001?'有效':'无效'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" v-if="$route.query.type !== 'check'" width="130" align="left" fixed="right">
            <template v-slot="{row,$index}">
              <el-button type="text"  size="mini" @click="handleAddQuestion(2,row,$index)" class="train-edit-btn">编辑</el-button>
              <el-button type="text" size="mini" @click="handleDelete(row,$index)"  class="train-delete-btn">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
        <div style="text-align: center">
          <el-button v-if="$route.query.type !== 'check'" type="primary" @click="handleAddQuestBank" style="background-color: #377F7F;color: #fff;">确认保存</el-button>
          <el-button  @click="handleBack" >返回上一页</el-button>
        </div>
    </el-form>
    <el-dialog
        :title=" isNew ? '新增题目' : '编辑题目'"
        :visible.sync="addQuestionDialog"
        width="60%"
        :before-close="handleClose">
      <add-question-dialog v-if="addQuestionDialog" :is-new="isNew" :currentQuestion="currentQuestion"
                           :question-id="questionId" ref="addQuest" :questIndex="questIndex"
                           @saveFormData="handleSaveQuest" @close="handleClose" @update="handleUpdate"></add-question-dialog>
      <span slot="footer" class="dialog-footer">
          <el-button @click="handleCloseAdd">取 消</el-button>
          <el-button type="primary" @click="handleSaveQuestion()">确认</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
import addQuestionDialog from "@/views/cloudTraining/question/components/addQuestionDialog.vue";
import {
  deleteQuestions,
  getRepositoryDtl,
  getRepositoryDtlTable,
  saveQuestions, saveQuestionsBatchCreate,
  updateQuestions,
  updateQuestionsRepository
} from "@/api/training";
import axios from "axios";
export default {
  name: "addQuestBank",
  components: {addQuestionDialog},
  data() {
    return {
      loading: false,
      loadingText: "正在加载...",
      isNew: true,
      currentQuestion: {},
      isImport: false,
      questionId: 0,
      fileInfo: {
        url: '',
        name: '',
        type: '', // 'pdf' 或 'video'
        mimeType: ''
      },
      dialogVisible: false,
      addQuestionDialog: false,
      questIndex:null,
      value: [],
      options2: [
        {value: '10', label: '10'},
        {value: '20', label: '20'},
        {value: '30', label: '30'},
        {value: '40', label: '40'},
        {value: '50', label: '50'},
        {value: '60', label: '60'},
        {value: '70', label: '70'},
        {value: '80', label: '80'},
        {value: '90', label: '90'},
        {value: '100', label: '100'},
        {value: '110', label: '110'},
        {value: '120', label: '120'},
      ],
      options: [],
      quetionList:[],
      fileList:[],
      videoUrl: '',
      studyTime:'',
      form: {
        remarks: "",
        title: "",

      },
      token: localStorage.getItem('token') ||localStorage.getItem('vue_token'),
      uploadHeaders: {
        Authorization: `Bearer ${this.token}` // 假设你的后端需要这样的 Authorization 头部格式
      },
    }
  },

  created() {
    if(this.$route.query.id){
      this.getDtl()
    }else{
      this.form = {}
      this.quetionList = []
    }
  },
  methods: {
    getDtl() {
      getRepositoryDtl( {id: this.$route.query.id}).then(res => {
        if (res.code === 200) {
          this.form = res.data.repository
          this.quetionList = res.data.questions

        }
      })
    },
    getQuestionType(typeId) { // 根据题型 ID 获取题型名称
      const typeMap = {
        2001: '单选题',
        2002: '多选题',
        2003: '是非题',
        2004: '填空题',
        2005: '问答题'
      };

      return typeMap[typeId] || '未知类型';
    },
    handleAddQuestion(type,row,index){
      this.questIndex = index
      this.addQuestionDialog = true
      if(type == 2){
        this.isNew =false
        if(row.question_id){
          this.questionId = row.question_id
        }else{
          this.currentQuestion = row
        }
      }else{
        this.isNew = true
        this.currentQuestion = {

        }
        this.questionId = 0
      }
    },
    handleAddQuestBank(){ //保存题库
      if(!this.form.title){
        this.$message.error('请填写题库名称')
        return
      }
      if(this.quetionList.length == 0){
        this.$message.error('请添加题目')
        return
      }

      this.loading = true
      this.loadingText = '正在保存，请稍等...'
      if(!this.$route.query.id){
        this.quetionList.forEach(item=>{
          if([2001,2002,2003].includes(item.question_type) && !this.isImport ){
            // item.option_text_str = item.options.map(item=> (item.value+ ':'+ item.option_text)).toString()
            item.option_text_str = item.options.map(item => `${item.value}:${item.option_text}`).join(';');
            item.answer = item.correct_letters
          }else{
            if(!this.isImport){
              item.option_text_str = item.options || ''
              item.answer = item.options || ''
            }

          }
        })
      }
      if(this.$route.query.id){ //更新
        let paramas2= {
          repository_id: this.$route.query.id,
          title: this.form.title,
          remarks: this.form.remarks,
        }
        updateQuestionsRepository(paramas2).then(res => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.$router.push({path: '/cloudTraining/exam/questionBankList'})
          }else{
            this.$message.error(res.msg)
          }
        }).finally(() => {
          this.loading = false
        })
      }else{ // 新增
         let paramas1 = {
        repository: {
          title: this.form.title,
          remarks: this.form.remarks,
        },
        questions: this.quetionList
      }
        saveQuestionsBatchCreate(paramas1).then(res => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.$router.push({path: '/cloudTraining/exam/questionBankList'})
          }else{
            this.$message.error(res.msg)
          }
        }).finally(() => {
          this.loading = false
        })
      }
      updateQuestions().then(res => {
        if (res.code === 200) {
          this.$message.success('保存成功')
          this.$router.push({path: '/cloudTraining/questionBankList'})
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleRemove(file, fileList) {
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleChangeUpload(){},
    beforeVideoUpload(file) {
      const fileType = file.type
      const fileName = file.name.toLowerCase()
      const isPDF = fileName.endsWith('.pdf') && fileType === 'application/pdf'
      const isVideo = fileType.startsWith('video/')

      if (!isPDF && !isVideo) {
        this.$message.error('仅支持上传 PDF 或视频文件！')
        return false
      }

      // 大小限制
      const maxSize = isPDF ? 50 * 1024 * 1024 : 200 * 1024 * 1024 // PDF 50MB，视频 200MB
      if (file.size > maxSize) {
        const maxMB = isPDF ? 50 : 200
        this.$message.error(`文件大小不能超过 ${maxMB}MB！`)
        return false
      }
      return true
    },
    handleUploadSuccess(response, file, fileList) {
      // 假设后端返回 { url: '...', originalName: 'xxx.pdf', mimeType: 'application/pdf' }
      const { url, originalName, mimeType } = response

      if (!url) {
        this.$message.error('上传失败：未返回文件地址')
        return
      }
      const isPDF = mimeType === 'application/pdf'
      const isVideo = mimeType.startsWith('video/')

      if (isPDF || isVideo) {
        this.fileInfo = {
          url,
          name: originalName || file.name,
          type: isPDF ? 'pdf' : 'video',
          mimeType
        }
        this.$message.success('上传成功！')
      } else {
        this.$message.error('不支持的文件类型')
      }
    },

    handleUploadError(err) {
      this.$message.error('上传失败，请重试')
    },
    handleBeforeUpload(file) {
      const fileType = file.type
      const fileName = file.name.toLowerCase()
      // 大小限制
      const maxSize =  50 * 1024 * 1024  // PDF 50MB，视频 200MB
      if (file.size > maxSize) {
        const maxMB = 50
        this.$message.error(`文件大小不能超过 ${maxMB}MB！`)
        return false
      }

      return true
    },
    handleImport(){

    },
    handleClose() {
      this.addQuestionDialog = false
    },
    handleCloseAdd(){
      this.addQuestionDialog = false
      this.$refs.addQuest.resetForm()

    },
    handleConfirmExport(){
      this.loading = true
      this.loadingText = '正在下载，请稍等...'
      // 题库模板地址
      let url = 'https://image-hw.51ipoct.cn/tmp/excel/题库导入模版-V1.0.xlsx'
      return new Promise((resolve, reject) => {
        const fileName = url.split('/').pop()
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.download = fileName
        // 这个延迟操作的目的是为了确保浏览器有足够的时间来处理下载操作
        // 这样可以避免在循环中快速触发多个下载操作，导致浏览器无法正确处理下载请求
        link.addEventListener('click', () => {
          setTimeout(() => {
            resolve()
          }, 1000)
        })
        link.click()
      }).finally(()=>{this.loading = false})
    },
    handleBack(){
      if(this.$route.query.type == 'exam'){
        this.$router.push({path:'/cloudTraining/exam/examList'})
      }else{
        this.$router.push({path:'/cloudTraining/exam/questionBankList'})
      }
    },
    handleSaveQuestion(){ //保存单个题目内容
      this.$refs.addQuest.saveFormData()
    },
    handleUpdate(){
      this.addQuestionDialog = false
      this.getDtl()
    },
    handleSaveQuest(data){ //新增题库新增题目保存本地最后提交 ,本地保存
      let temp = JSON.parse(JSON.stringify(data))

      if([2001,2002,2003].includes(temp.question_type) ){
        temp.options_str = temp.options.map(item => `${item.value}:${item.option_text}`).join(';');
        temp.option_text_str = temp.options_str
        // 2. ✅ 正确生成 correct_letters（支持多选！）
        temp.correct_letters = temp.options
            .filter(opt => opt.is_correct)
            .map(opt => opt.value)
            .join(',');
        temp.answer = temp.correct_letters;
        temp.answer = temp.correct_letters
      }else{
        // temp.options_str = temp.options
        temp.correct_letters = temp.options
      }
      if(temp.questIndex != null){
        const newList = [...this.quetionList];
        newList[temp.questIndex] = temp;
        this.quetionList = newList; // ✅ 触发响应式更新
        // this.quetionList[temp.questIndex] = JSON.parse(JSON.stringify(temp))
      }else{
        this.quetionList = [...this.quetionList, temp];
        // this.quetionList.push(temp)
      }

      this.addQuestionDialog = false
    },
    handleDelete(row,index){
     // 二次确认弹窗
      const h = this.$createElement
      this.$confirm('提示', {
        title: '提示',
        message: h('div', [h('p', `确认删除这道题目吗？`),]),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
       if(row && row.question_id ){
         deleteQuestions({id: row.question_id}).then(res => {
           if (res.code === 200) {
             this.$message.success('删除成功')
             this.getDtl()
           }
         })
       }else{
         this.quetionList.splice(index,1)
       }
      })


    },
    handleUpload(file) {
      const formData = new FormData();
      formData.append('file', file.file); // 注意：在某些 Element UI 版本中，可能需要使用 file.file 而不是 file.raw
      if(this.$route.query.id){
        formData.append('repository_id', this.$route.query.id ); //编辑的时候需要传入题库id
      }

      const config = {
        headers: {
          'Authorization': `Bearer ${this.token}` // 假设 token 已经在 data 或 computed 中定义
        }
      };
      let baseUrl= process.env.VUE_APP_BASE_API
      axios.post(`${baseUrl}/api/repository/batch/import/`, formData, config)
          .then(res => {
            if(res.data.code ==200){
              // 处理响应
              if(this.$route.query.id){
                this.getDtl()
              }else{
                let resData = res.data.data
                this.quetionList = resData.questions
                this.quetionList.forEach(item => {
                  item.options_str = item.option_text_str

                  item.correct_letters = item.answer
                  item.options = item.options_str.split(';')
                  item.options = this.parseOptionsFromStr(item.options_str, item.correct_letters)
                })
                this.form = resData.repository
                this.isImport = true
              }
            }else if(res.data.code == 201){
              this.$message.error(res.data.msg)
            }


            // let resUrl =  data.data.data.urls[0]
            // this.form.file_url = resUrl
            // this.fileList.push({url: resUrl, name: file.file.name, uid: file.file.uid})
          })
          .catch(error => {
            // 处理错误
          });
    },
    parseOptionsFromStr(options_str = '', correct_letters = '') { //一键导入文件转化选项options
      const correctSet = new Set(
          correct_letters ? correct_letters.split(',').map(s => s.trim()) : []
      );

      return options_str
          .split(';')
          .filter(part => part.trim())
          .map((part, index) => {
            // 处理 "A:文本" 格式，支持文本中包含冒号
            const colonIndex = part.indexOf(':');
            let value = '';
            let option_text = part;

            if (colonIndex > 0) {
              value = part.substring(0, colonIndex).trim();
              option_text = part.substring(colonIndex + 1).trim();
            } else {
              // 没有冒号？用 A/B/C... 自动生成 value
              value = String.fromCharCode(65 + index);
            }

            return {
              value,
              option_text,
              is_correct: correctSet.has(value),
              sort_order: index
            };
          });
    }

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form-item{
  display: inline-block;
  width: 100%;
}
.wrap{
  background: #fff;
  margin:10px;
  padding: 30px 40px;
  box-sizing: border-box;
  height: 100%
}
::v-deep .el-table thead th{
  background: #E8E8E8;
  color: #000;
  padding :0;
}
.status_tag{
  padding:10px 18px;
  color: #fff;
  border-radius: 10px;
}
.train-edit-btn{
  color:#567722;
}
.train-delete-btn {
  color:#E34D59;
}

</style>